import { TimeInterval, defaultTimeInterval, CompletionStatus } from '../../api';
import { Interaction } from './interaction';
import { Score, defaultScore } from './score';
import { SuccessStatus } from './success-status';
import { Objective } from './objective';
import { Exit } from '../../api/exit';

export interface Model {
  model: StateModel;
}

interface StudentInfo {
  id: string
  fullName: string
}

export interface StateModel {
  completionStatus: CompletionStatus;
  successStatus: SuccessStatus;
  location: string;
  suspendData: string;
  sessionTime: TimeInterval;
  score: Score;
  interactions: Interaction[];
  objectives: Objective[];
  exit: Exit;
  studentInfo: StudentInfo;
}

export function defaultStateModel(): StateModel {
  return {
    completionStatus: CompletionStatus.unknown,
    successStatus: SuccessStatus.unknown,
    location: '',
    suspendData: '',
    sessionTime: defaultTimeInterval(),
    score: defaultScore(),
    interactions: [],
    objectives: [],
    exit: Exit.none,
    studentInfo: {
      id: 'student',
      fullName: 'Student'
    }
  };
}

export function defaultModel(): Model {
  return {
    model: defaultStateModel()
  };
}
